import { render, staticRenderFns } from "./TabsC.vue?vue&type=template&id=05c5e27e&lang=pug&"
import script from "./TabsC.vue?vue&type=script&lang=js&"
export * from "./TabsC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports